import React from 'react'
import '../styles.css'
import ReactTyped from "react-typed";
import {useNavigate} from 'react-router-dom';

export default function HeadingSection(){
  const navigate = useNavigate();
  const navigateToSignup = () => {
   
    navigate('/signup');
  };
    return(
         <div id = 'heading-section'>
                <div id = 'product-heading'>
                    <p id = 'header'>
                        PenPal.ai
                    </p>
                    <p id = 'sub-header'>{" "}
                        <ReactTyped strings={["End Writer's Block.","Unleash Your Creativity."]} typeSpeed={60} loop />
                    </p>
                    <button className = 'main-CTA' onClick = {navigateToSignup}>Try Now</button>
                </div>
                <div id = 'design-element'>
                    <div id = 'row1'>
                        <div className = 'circle-elem'></div>
                        <div className = 'square-elem'></div>
                        <div className = 'circle-elem'></div>
                    </div>
                    <div id = 'row2'>
                        <div className = 'square-elem'></div>
                        <div className = 'circle-elem'></div>
                        <div className = 'square-elem'></div>
                    </div>
                    <div id = 'row3'>
                        <div className = 'circle-elem'></div>
                        <div className = 'square-elem'></div>
                <       div className = 'circle-elem'></div>
                    </div>
             </div>
        </div>
);
}